module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "feedback-knowledge-js": "static-1.4498",
      "hs-test-utils": "static-1.7060",
      "I18n": "static-7.1405",
      "jasmine-runner": "static-1.5484",
      "quartz": "static-1.5822",
      "hubspot-url-utils": "static-1.3354",
      "outpost": "static-1.3416",
      "PatternValidationJS": "static-1.437",
      "react": "static-7.151",
      "moment": "static-3.26",
      "foundations-components": "static-1.6415",
      "framer-motion": "static-1.43",
      "hs-test-utils-bend-plugin": "static-1.2171",
      "msw": "static-1.39",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.125",
      "enviro": "static-4.313",
      "i18n-data": "static-1.200",
      "metrics-js": "static-1.8821",
      "moment-timezone": "static-5.51",
      "react-utils": "static-2.4528",
      "jasmine": "static-4.3412",
      "PortalIdParser": "static-2.291",
      "quartz-core-utils": "static-1.2689",
      "StyleGuideUI": "static-3.468",
      "quartz-core": "static-1.5041",
      "csstype": "static-1.38",
      "bend-plugin-foundations-components": "static-1.2684",
      "floating-ui": "static-1.31",
      "foundations-assets": "static-1.3964",
      "foundations-theming": "static-1.3369",
      "foundations-theming-specialty": "static-1.1086",
      "hs-story-utils": "static-1.8427",
      "react-aria": "static-1.41",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.76",
      "styled-components": "static-2.64",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.332",
      "ui-images": "static-2.901",
      "hoist-non-react-statics": "static-3.9",
      "copilot-toolkit": "static-1.7785",
      "dispatcher": "static-1.115",
      "general-store": "static-6.20",
      "HeadJS": "static-2.587",
      "history": "static-4.47",
      "hs-promise-rejection-tracking": "static-1.4585",
      "hub-http": "static-1.4807",
      "hub-http-janus": "static-1.660",
      "hub-http-shared-msw-handlers": "static-1.7425",
      "hubspotter-http": "static-1.3791",
      "hubspotter-http-shared-msw-handlers": "static-1.7423",
      "icons": "static-2.592",
      "mobile-manifest-mixins": "static-1.358",
      "platform-navigation-bootstrap": "static-1.11485",
      "quick-fetch": "static-1.2772",
      "raven": "static-3.5056",
      "raven-hubspot": "static-1.5363",
      "react-rhumb": "static-1.15626",
      "react-router-dom": "static-5.26",
      "UIComponents": "static-3.7528",
      "webpack-env": "static-1.54",
      "bend-plugin-foundations-theming": "static-1.1852",
      "foundations-theming-base": "static-1.2354",
      "react-input-autosize": "static-2.17",
      "classnames": "static-2.10",
      "chatspot-client-types": "static-1.9141",
      "chatspot-core": "static-1.17192",
      "ts-schema": "static-1.3317",
      "sassPrefix": "static-1.134",
      "platform-infra-nav-components": "static-1.6903",
      "cssUtils": "static-1.540",
      "head-dlb": "static-1.4210",
      "HubStyle": "static-2.10889",
      "HubStyleTokens": "static-2.10581",
      "hs-lodash": "static-4.45"
    },
    "depPathPrefixes": {
      "feedback-knowledge-js": "/feedback-knowledge-js/static-1.4498",
      "hs-test-utils": "/hs-test-utils/static-1.7060",
      "I18n": "/I18n/static-7.1405",
      "jasmine-runner": "/jasmine-runner/static-1.5484",
      "quartz": "/quartz/static-1.5822",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3354",
      "outpost": "/outpost/static-1.3416",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react": "/react/static-7.151",
      "moment": "/moment/static-3.26",
      "foundations-components": "/foundations-components/static-1.6415",
      "framer-motion": "/framer-motion/static-1.43",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2171",
      "msw": "/msw/static-1.39",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.125",
      "enviro": "/enviro/static-4.313",
      "i18n-data": "/i18n-data/static-1.200",
      "metrics-js": "/metrics-js/static-1.8821",
      "moment-timezone": "/moment-timezone/static-5.51",
      "react-utils": "/react-utils/static-2.4528",
      "jasmine": "/jasmine/static-4.3412",
      "PortalIdParser": "/PortalIdParser/static-2.291",
      "quartz-core-utils": "/quartz-core-utils/static-1.2689",
      "StyleGuideUI": "/StyleGuideUI/static-3.468",
      "quartz-core": "/quartz-core/static-1.5041",
      "csstype": "/csstype/static-1.38",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2684",
      "floating-ui": "/floating-ui/static-1.31",
      "foundations-assets": "/foundations-assets/static-1.3964",
      "foundations-theming": "/foundations-theming/static-1.3369",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1086",
      "hs-story-utils": "/hs-story-utils/static-1.8427",
      "react-aria": "/react-aria/static-1.41",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.76",
      "styled-components": "/styled-components/static-2.64",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.332",
      "ui-images": "/ui-images/static-2.901",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "copilot-toolkit": "/copilot-toolkit/static-1.7785",
      "dispatcher": "/dispatcher/static-1.115",
      "general-store": "/general-store/static-6.20",
      "HeadJS": "/HeadJS/static-2.587",
      "history": "/history/static-4.47",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4585",
      "hub-http": "/hub-http/static-1.4807",
      "hub-http-janus": "/hub-http-janus/static-1.660",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7425",
      "hubspotter-http": "/hubspotter-http/static-1.3791",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7423",
      "icons": "/icons/static-2.592",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.358",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11485",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "raven": "/raven/static-3.5056",
      "raven-hubspot": "/raven-hubspot/static-1.5363",
      "react-rhumb": "/react-rhumb/static-1.15626",
      "react-router-dom": "/react-router-dom/static-5.26",
      "UIComponents": "/UIComponents/static-3.7528",
      "webpack-env": "/webpack-env/static-1.54",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1852",
      "foundations-theming-base": "/foundations-theming-base/static-1.2354",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "classnames": "/classnames/static-2.10",
      "chatspot-client-types": "/chatspot-client-types/static-1.9141",
      "chatspot-core": "/chatspot-core/static-1.17192",
      "ts-schema": "/ts-schema/static-1.3317",
      "sassPrefix": "/sassPrefix/static-1.134",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6903",
      "cssUtils": "/cssUtils/static-1.540",
      "head-dlb": "/head-dlb/static-1.4210",
      "HubStyle": "/HubStyle/static-2.10889",
      "HubStyleTokens": "/HubStyleTokens/static-2.10581",
      "hs-lodash": "/hs-lodash/static-4.45"
    },
    "project": "feedback-knowledge-js",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};